var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pc"},[_c('div',{staticClass:"banner_content container"},[_c('p',{staticClass:"about-text d-none d-lg-block"},[_vm._v(" 在"),_c('span',[_vm._v("视频原生")]),_vm._v("的世界 "),_c('br'),_vm._v(" 构建一种更好的连接方式 ")]),_c('p',{staticClass:"about-text d-lg-none"},[_vm._v(" 在"),_c('span',[_vm._v("视频原生")]),_vm._v("的世界 "),_c('br'),_vm._v(" 构建一种更好的连接方式 ")])])])
}]

export { render, staticRenderFns }